import compose from 'recompose/compose';
import fromRenderProps from 'recompose/fromRenderProps';
import pure from 'recompose/pure';
import setHOCDisplayName from "../../../service/setHOCDisplayName";
import LoaderContext from "./LoaderContext";
var LoaderContextConsumer = LoaderContext.Consumer;
var withLoaderConsumer = compose(setHOCDisplayName('withLoaderConsumer'), fromRenderProps(LoaderContextConsumer, function (contextValue) {
  return {
    loaderHandler: contextValue
  };
}), pure);
export default withLoaderConsumer;